<template>
  <div class="marc-record">
    <div v-if="record" class="usa-table-container" tabindex="2">
      <table class="usa-table usa-table--striped">
        <tbody class="font-sans-xs">
          <tr>
            <td class="th-tag">LDR</td><td class="th-val">{{ record.leader }}</td>
          </tr>
          <marc-field v-for="(field, index) in record.fields"
                      :key="`f${index}`"
                      :field="field"/>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import MarcField from "./MarcField.vue"
export default {
  name: "MarcDisplay",
  components: {
    MarcField
  },
  props: {
    record: Object
  }
}
</script>

<style scoped>
.th-tag {
  width: 8%;
}
.th-val {
  width: auto;
}
</style>
